/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:600px){.responsive-container[_ngcontent-%COMP%]{margin:65px 42px 42px}}@media (max-width:599px){.responsive-container[_ngcontent-%COMP%]{padding:10px!important}}@media (max-width:968px){  mat-dialog-container{width:100vw!important}}"];
export { styles as styles };
